import { styled } from "goober";

export const NavigationStatus = styled("span")`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;

  &:not([data-mobile="true"]) {
    position: absolute;
    top: 50%;
    right: 4px;
    width: 24px;
    height: 24px;
    transform: translateY(-50%);
    pointer-events: none;
  }
`;
